class TranslateService {

  constructor() {
    this.translate = {};
  }

  async getTranslates() {
    const ruLocaleRequest = await fetch("/static/locales/ru.json");
    const ruLocale = await ruLocaleRequest.json()

    const enLocaleRequest =  await fetch("/static/locales/en.json");
    const enLocale = await enLocaleRequest.json()

    return {
      ru: ruLocale,
      en: enLocale
    };
  }
}

export const translateService = new TranslateService();



// WEBPACK FOOTER //
// ./src/services/translateService.js